import Component from '../abstracts/Component';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
//END WIP
import wnumb from 'wnumb';
import nouislider from "nouislider";

export default class PriceRangeComponent extends Component {
  get SELECTORS() {
    return {
      minInput: '.w-price-range [data-input-min]',
      minText: '.w-price-range [data-text-min]',
      maxInput: '.w-price-range [data-input-max]',
      maxText: '.w-price-range [data-text-max]',
      rangeSlider: '.w-price-range [data-range-slider]',
      resetBtn: '.w-price-range [data-range-reset]',
      //END WIP
      rangerBar: '.w-price-range',
      inputMin: '.w-price-range .input-min',
      inputMax: '.w-price-range .input-max',
      oldInputMin: '.w-price-range .old-input-min',
      oldInputMax: '.w-price-range .old-input-max',
      activeMin: '#selectedValueMin',
    };
  }

  get CSS_CLASSNAMES() {
    return {
      minValueSet: 'c-p-r__min-value-set',
      maxValueSet: 'c-p-r__max-value-set',
      //END WIP
      active: 'active',
    };
  }

  constructor(compEl) {
    super(compEl);
    //call on document to avoid NaN when resetFilters
    if (document.querySelector(this.SELECTORS.rangerBar) != null) {
      if (document.querySelector('#currentSliderMinValue')) {
        this.minVal = parseInt(document.querySelector('#currentSliderMinValue').innerHTML);
      } else {
        this.minVal = parseInt(document.querySelector('.w-price-range').dataset.rangeMin);
      }
      this.maxVal = parseInt(document.querySelector(this.SELECTORS.rangerBar).dataset.rangeMax);
      this.currentMin = parseInt(document.querySelector(this.SELECTORS.rangerBar).dataset.min);
      this.currentMax = parseInt(document.querySelector(this.SELECTORS.rangerBar).dataset.max);
    }
    this.minText = this.$component.querySelector(this.SELECTORS.minText);
    this.maxText = this.$component.querySelector(this.SELECTORS.maxText);
    this.minInput = this.$component.querySelector(this.SELECTORS.minInput);
    this.maxInput = this.$component.querySelector(this.SELECTORS.maxInput);
    this.resetBtn = document.querySelector(this.SELECTORS.resetBtn);
    this.rangeSlider = document.querySelector(this.SELECTORS.rangeSlider);
    this.resetSlider = this.resetSlider.bind(this);
    this.rangerBar = this.$component.querySelector(this.SELECTORS.rangerBar);
    this.inputMin = this.$component.querySelector(this.SELECTORS.inputMin);
    this.inputMax = this.$component.querySelector(this.SELECTORS.inputMax);
    this.oldInputMin = this.$component.querySelector(this.SELECTORS.oldInputMin);
    this.oldInputMax = this.$component.querySelector(this.SELECTORS.oldInputMax);
  }

  render() {
    super.render();
    this.init();
    this.setSliderChangeHandler();
    //END WIP
    // launch slider
    if (this.rangerBar != null) {
      this.initSlider(this.rangerBar);
    }
    // TODO: Fix slider init
    window.addEventListener('load', () => {
      this.bindEvents();
    });
  }

  init() {
    this.updateTexts();
    this.updateInputs();
    noUiSlider.create(this.rangeSlider, {
      start: [this.currentMin, this.currentMax],
      connect: true,
      range: {
        min: this.minVal,
        max: this.maxVal,
      },
      step: 10,
      format: {
        from: function (value) {
          return Number(value)
            .toString()
            .replace('.-', '');
        },
        to: function (value) {
          return Number(value)
            .toString()
            .replace('.-', '');
        },
      },
    });
    const handles = this.rangeSlider.querySelectorAll('.noUi-handle');

    handles.forEach((handle, index) => {
      // for accessibility nav + screen reader
      handle.setAttribute('tabindex', '0');
      handle.setAttribute('role', 'slider');
      handle.setAttribute('aria-valuemin', this.minVal);
      handle.setAttribute('aria-valuemax', this.maxVal);
      handle.setAttribute('aria-orientation', 'horizontal');
      handle.setAttribute('aria-label', index === 0 ? 'Min Price' : 'Max Price');
    });
  }

  renderNewSlider() {
    if (this.rangeSlider.noUiSlider && this.rangeSlider.noUiSlider != 'undefined') {
      this.rangeSlider.noUiSlider.destroy();
    }
    this.init();
    this.setSliderChangeHandler();
    // launch slider
    if (this.rangerBar != null) {
      this.initSlider(this.rangerBar);
    }
  }

  setSliderChangeHandler() {
    this.rangeSlider.noUiSlider.on('update', () => {
      var values = this.rangeSlider.noUiSlider.get();
      // noUiSlider sometimes returns value with 0.0000001 difference (eg 239.99999), avoid it by rounding up
      this.currentMin = Math.round(parseFloat(values[0]));
      this.currentMax = Math.round(parseFloat(values[1]));
      this.updateTexts();
      this.updateInputs();
      this.toggleResetVisibility(this.isSliderChanged(this.rangeSlider));
    });
    this.resetBtn.addEventListener('click', this.resetSlider);
  }

  isSliderChanged(rangeSlider) {
    if (rangeSlider == null) {
      // price filter not present in page (ex. algolia search)
      return false;
    }
    var values = rangeSlider.noUiSlider.get();
    this.currentMin = parseInt(values[0]);
    this.currentMax = parseInt(values[1]);

    return this.currentMin !== this.minVal || this.currentMax !== this.maxVal;
  }

  updateTexts() {
    this.minText.innerHTML = this.currentMin.toString().replace('.-', '');
    this.maxText.innerHTML = this.currentMax.toString().replace('.-', '');
    if (this.currentMin == this.minVal) {
      this.$component.classList.remove(this.CSS_CLASSNAMES.minValueSet);
    } else {
      this.$component.classList.add(this.CSS_CLASSNAMES.minValueSet);
    }
    if (this.currentMax == this.maxVal) {
      this.$component.classList.remove(this.CSS_CLASSNAMES.maxValueSet);
    } else {
      this.$component.classList.add(this.CSS_CLASSNAMES.maxValueSet);
    }
  }

  updateInputs() {
    this.minInput.value = this.currentMin.toString().replace('.-', '');
    this.maxInput.value = this.currentMax.toString().replace('.-', '');
  }

  resetSlider() {
    if (this.rangeSlider == null) {
      return;
    }
    this.minVal = parseInt(document.querySelector(this.SELECTORS.rangerBar).dataset.rangeMin);
    this.maxVal = parseInt(document.querySelector(this.SELECTORS.rangerBar).dataset.rangeMax);
    this.rangeSlider.noUiSlider.set([this.minVal, this.maxVal]);
    this.toggleResetVisibility(false);
  }

  toggleResetVisibility(show) {
    if (show) {
      this.resetBtn.style.opacity = 1;
    } else {
      this.resetBtn.style.opacity = 0;
    }
  }

  //END WIP
  getAllRanges(element) {
    if (element != null) {
      // let's take data
      let data = element.dataset;
      // vars
      let all = data["all"];
      let allSplitted = all.split("|");
      // ascending order set
      const sortAsc = (a, b) => a - b;
      allSplitted.sort(sortAsc);
      //
      return allSplitted;
    }
  }

  // range functions
  getOptions(sliderElement) {
    // let's take data
    let data = sliderElement.dataset;
    // vars
    let rangeAllSliders = {};
    let allSplitted = this.getAllRanges(sliderElement);
    //
    let cnt = allSplitted.length;
    let setMinIndexTo = 0;
    let setMaxIndexTo = cnt - 1;
    let facetName = data['facetName'];
    let rangeMin = data['rangeMin'];
    let rangeMax = data['rangeMax'] || 100;
    // Set start min and start max from current query
    let currentQuery = data['currentQuery'];
    let setMinTo = undefined;
    let setMaxTo = undefined;
    let currency = sliderElement.getAttribute("data-currency");
    //
    if (currentQuery) {
      let rx = new RegExp("(:" + facetName + ":([0-9]+))", "g");
      let matches = currentQuery.match(rx);
      if (matches) {
        setMinTo = data['min'];
        setMaxTo = data['max'];
      }
    }
    // Otherwise from html
    if (!setMinTo) {
      setMinTo = sliderElement.querySelector(".input-min").value;
    }
    if (!setMaxTo) {
      setMaxTo = sliderElement.querySelector(".input-max").value;
    }
    /**
     *
     * E.g.
     * var range_all_sliders = {
     *   min: 0,
     *   '16%': 140,
     *   '25%': 150,
     *   '33%': 160,
     *   '42%': 170,
     *   '50%': 180,
     *   '58%': 190,
     *   '67%': 200,
     *   '75%': 220,
     *   '83%': 230,
     *   '91%': 260,
     *   max: 290,
     * }
     *
     */
    // if splitted is more than 2 intervals
    if (cnt >= 2) {
      for (var i = 0; i < cnt; i++) {
        let perc = Math.floor(100 * i / (cnt - 1));
        if (i == setMinIndexTo) {
          rangeAllSliders["min"] = parseInt(allSplitted[i]);
        } else if (i == setMaxIndexTo) {
          rangeAllSliders["max"] = parseInt(allSplitted[i]);
        } else {
          rangeAllSliders[perc + "%"] = parseInt(allSplitted[i]);
        }
      }
    }

    // build opts
    let opts = {
      start: [setMinTo || rangeMin, setMaxTo || rangeMax],
      connect: data['connect'] || true,
      snap: data['snap'] || true,
      range: rangeAllSliders,
      tooltips: true,
      format: wnumb({
        'decimals': 0,
        'thousand': '',
        'postfix': ' ' + currency
      }),
      pips: {
        mode: 'range'
      }
    };

    console.info("[Ranges] Slider init with opts: ", opts);

    return opts;
  }


  initSlider(slider) {
    // take options
    let ctx = this;
    let opts = this.getOptions(slider);
    let currency = slider.getAttribute("data-currency");

    // launch slider
    nouislider.create(slider, opts);

    // remove extra marker
    let noUinormals = slider.querySelectorAll(".noUi-marker-normal,.noUi-value-horizontal");
    if (noUinormals != null) {
      noUinormals.forEach(single => {
        single.remove();
      });
    }

    // change slider
    slider.noUiSlider.on('change', function (values, handle) {
      // vars
      let oldMinVal = ctx.oldInputMin.value;
      let oldMaxVal = ctx.oldInputMax.value;
      let minVal = values[0].replace(currency, '').trim();
      let maxVal = values[1].replace(currency, '').trim();
      // setting values
      ctx.inputMin.value = minVal;
      ctx.inputMax.value = maxVal;
      // Logging
      console.debug("[Ranges]: minVal " + minVal + " oldMinVal " + oldMinVal);
      console.debug("[Ranges]: maxVal " + maxVal + " oldMaxVal " + oldMaxVal);
      // Save curr values as old ones
      slider.querySelector(".old-input-min").value = minVal;
      slider.querySelector(".old-input-max").value = maxVal;
    });
  }

  updateSlider(response) {
    let updatedRangerBar = response.querySelector(this.SELECTORS.rangerBar);
    let updatedMin = response.querySelector(this.SELECTORS.inputMin);
    let updatedMax = response.querySelector(this.SELECTORS.inputMax);
    // data-min data-max data-current-query
    // setting values
    this.inputMin.value = updatedMin.value;
    this.inputMax.value = updatedMax.value;


    let newOpts = this.getOptions(updatedRangerBar);

    this.rangerBar.noUiSlider.updateOptions(
      newOpts, // Object
      true // Boolean 'fireSetEvent'
    );

  }

  buildQuery(isReset) {
    // take values
    if (document.querySelector('.w-price-range') == null) {
      return '';
    }
    this.rangerBar = document.querySelector('.w-price-range');
    let allSplitted = this.getAllRanges(this.rangerBar);

    let minVal = this.rangerBar.querySelector('[data-input-min]').value;
    let maxVal = this.rangerBar.querySelector('[data-input-max]').value;
    let rangeMin = this.rangerBar.getAttribute("data-range-min");
    let rangeMax = this.rangerBar.getAttribute("data-range-max");
    let facetName = this.rangerBar.getAttribute("data-facet-name");

    let query = '';
    let count;

    if ((rangeMin !== minVal || rangeMax !== maxVal) && !isReset) {
      query = ':';
      for (var i = 0; i < allSplitted.length; i++) {
        if (parseInt(allSplitted[i]) <= parseInt(minVal) && !(i === 0 && allSplitted[i] === minVal && minVal === rangeMin)) {
          // if is less (or NOT: first and equal to min values) jump it
          continue;
        } else if ((parseInt(allSplitted[i]) <= maxVal) && count == null) {
          // first price filter
          query += facetName + ":" + allSplitted[i];
          count = 1;
        } else if ((parseInt(allSplitted[i]) <= maxVal) && count != null) {
          // first price filter
          query += ":" + facetName + ":" + allSplitted[i];
        } else {
          break;
        }
      }
      if (query === ':') {
        //avoids broken query
        query += facetName + ":" + maxVal;
      }
    } else {
      query = '';
    }
    return query;
  }

  //TODO: fix slider init
  bindEvents() {
    this.$on(this.$customEvents.FILTERS_EVENTS.filtersReset, () => {
      // reset sliders
      this.initSlider(document.querySelector(this.SELECTORS.rangerBar));
    });
  }

}
